import { useEffect, useState } from "react";
import "./index.css";
import { data as fallbackData } from "./data";
import { fetchPortfolioData } from "./api";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AdminDashboard from "./components/AdminDashboard";

export default function App() {
  const [data, setData] = useState(fallbackData);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState("");
  const isAdmin = window.location.pathname === "/admin";

  useEffect(() => {
    let mounted = true;

    fetchPortfolioData()
      .then((portfolioData) => {
        if (!mounted) return;
        setData(portfolioData);
        setApiError("");
      })
      .catch((error) => {
        if (!mounted) return;
        setApiError(error.message);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  if (isAdmin) {
    return (
      <AdminDashboard
        data={data}
        loading={loading}
        apiError={apiError}
        onSaved={setData}
      />
    );
  }

  return (
    <>
      <Navbar name={data.name} />
      {apiError && (
        <div className="api-status-banner">
          Showing local sample data. Start the backend to load saved updates.
        </div>
      )}
      <main>
        <Hero data={data} />
        <hr style={{ border: "none", borderTop: "1px solid var(--border)" }} />
        <About data={data} />
        <hr style={{ border: "none", borderTop: "1px solid var(--border)" }} />
        <Projects data={data} />
        <hr style={{ border: "none", borderTop: "1px solid var(--border)" }} />
        <Experience data={data} />
        <hr style={{ border: "none", borderTop: "1px solid var(--border)" }} />
        <Contact data={data} />
      </main>
      <Footer name={data.name} resumeUrl={data.resumeUrl} />
    </>
  );
}
